import { render } from "./Patrimonio.vue?vue&type=template&id=04220ef7&scoped=true"
import script from "./Patrimonio.vue?vue&type=script&lang=js"
export * from "./Patrimonio.vue?vue&type=script&lang=js"

import "./Patrimonio.vue?vue&type=style&index=0&id=04220ef7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04220ef7"]])

export default __exports__